/* EMINOVÈE fail-closed: legacy quick-view is intentionally disabled. */
(function (window) {
  'use strict';
  if (!window.jQuery) return;
  window.jQuery(document).on('click.eminoveeGate', '.quickview, .btn-quickview', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  });
}(window));
